<template >
  <div>
    <div class="imgUp">
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="uploadUrl"
        :before-upload="beforeAvatarUpload"
        :show-file-list="false"
        :data="uploadData"
        :on-change="uploadChange"
        :on-success="(res) => uploadImgFun(res, 2)"
        :file-list="img"
        :limit="5"
      >
        <el-button size="small"  type="primary">点击上传</el-button>
        <div slot="tip" style="margin-top: 6px;margin-left: 10px">支持扩展名：.rar .zip .doc .docx .pdf .jpg...</div>
      </el-upload>
      <div v-for="(item,index) in img" :key="index">
        <div class="upload">{{item.name}}
          <div>
            <i class="el-icon-loading" v-if="item.status !=='success'"></i>
            <i class="el-icon-zoom-in" @click="handlePictureCardPreview(item,index)"
               v-if="item.name.substring(item.name.indexOf('.')) === '.jpeg'
                                 ||item.name.substring(item.name.indexOf('.')) === '.png'
                                 ||item.name.substring(item.name.indexOf('.')) === '.jpg'
                                 ||item.name.substring(item.name.indexOf('.')) === '.JPG'
                                 || item.name.substring(item.name.indexOf('.')) === '.gif'"></i>
            <i class="el-icon-upload2" @click="uploadClick(item,index)"></i>
            <i class="el-icon-delete" @click="handleRemove(item,index)"></i></div>
        </div>
      </div>

    </div>
    <el-dialog :visible.sync="dialogVisible" append-to-body >
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import {getSessionStore} from "@/config/mUtils";
import {baseUrl} from "@/config/env";

export default {
  data(){
    return {
      uploadFlag:false,//替换
      uploadIndex:'',//替换索引
      uploadData: { //参数
        fileType: 0,
      },
      img:[],
      dialogVisible:false,//查看显示
      dialogImageUrl:'',//查看图片路径
    }
  },
  watch:{

  },
  props:{
    // 上传地址
    uploadUrl:{
      default:'',
    },
    limit:{
      default:1,
    }
  },
  methods:{
    beforeAvatarUpload(file) {
      const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg','application/pdf','text/plain','application/x-zip-compressed','application/vnd.ms-excel','application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document']
      const isJPG =TypeArr.includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isJPG) this.$message.error('上传附件格式不符合规范！')
      if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB')

      return isJPG && isLt10M
      // return isLt10M
    },
    /**
     * 上产改变
     * @param file 上传文件信息
     * @param fileList 所有上传文件信息列表
     */
    uploadChange(file, fileList){
      //判断是否替换 true
      if (this.uploadFlag){
        // 根据索引 替换
        this.img.splice(this.uploadIndex,1,file)
        this.uploadFlag = false
      }else {
        this.img = fileList;
      }
      //判断是否有返回体
      if (Object.keys(file).includes('response')){
        //判断是否上传失败
        if (file.response.status !==0){
          //上传失败删除
          this.img.splice(this.img.indexOf(file),1)
        }
      }
    },
    //附件上传成功回调
    uploadImgFun(res, val) {
      if (res.status === 0) {
        this.$message.success(res.message);

      } else {
        this.$message.error(res.message);
        this.uploadFlag =false;

      }
    },
    //图片查看
    handlePictureCardPreview(item,index){
      console.log(item)
      let token = getSessionStore('token');
      this.dialogImageUrl = baseUrl + "/web/attachmentFtp/download?attachmentId="+(item.id||item.response.data.id)+"&access_token="+token;

      this.dialogVisible = true;
    },
    /**
     * 外部上传方法，替换
     * @param item 文件信息
     * @param index 替换索引
     */
    uploadClick(item,index){
      this.uploadIndex= index
      this.uploadFlag = true
      this.$refs.upload.$refs['upload-inner'].handleClick()

    },
    /**
     * 删除
     * @param item
     * @param index 索引
     */
    handleRemove(item,index) {
      this.img.splice(index,1)
    },
  }
}
</script>

<style lang="scss" scoped>
  .imgUp{
    .upload-demo{
      display: flex;
    }
    .upload{
      font-size: 17px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      i{
        margin-right: 10px;
      }
      i:hover{
        color: #00e1ff;
      }
    }
  }
</style>
